import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Content, Overlay, Wrapper } from './styles';
import { carbonFiltersEnum } from './enums';
import Date from './Date';
import Subsidiaries from './Subsidiaries';
import Regions from './Regions';
import Invoice from './Invoice';
import Customers from './Customers';
import Modal from './Modal';
import { changeFilters, getCarbonEmissionList } from '../../../../redux/carbon';

const CarbonFilters = ({ dispatch }) => {
  const [activeFilter, setActiveFilter] = useState(null);

  const _toggleFilter = filter => {
    setActiveFilter(activeFilter === filter ? null : filter);
  };

  const _applyDate = ({ initialDate, finalDate }) => {
    dispatch(
      changeFilters({
        initialPeriod: initialDate,
        finalPeriod: finalDate,
      }),
    );
    dispatch(getCarbonEmissionList());

    _toggleFilter(carbonFiltersEnum.DATE);
  };

  const _applySubsidiariesFilter = listCompany => {
    dispatch(changeFilters({ listCompany }));
    dispatch(getCarbonEmissionList());

    _toggleFilter(carbonFiltersEnum.SUBSIDIARIES);
  };

  const _applyRegionFilter = listRegion => {
    dispatch(changeFilters({ listRegion }));
    dispatch(getCarbonEmissionList());

    _toggleFilter(carbonFiltersEnum.REGIONS);
  };

  const _applyNFTypeFilter = nfType => {
    dispatch(changeFilters({ nfType }));
    dispatch(getCarbonEmissionList());

    _toggleFilter(carbonFiltersEnum.NF_TYPE);
  };

  const _applyModal = modal => {
    dispatch(changeFilters({ modal }));
    dispatch(getCarbonEmissionList());

    _toggleFilter(carbonFiltersEnum.MODAL);
  };

  const _applyCustomersFilter = listCustomerTMS => {
    dispatch(changeFilters({ listCustomerTMS }));
    dispatch(getCarbonEmissionList());

    _toggleFilter(carbonFiltersEnum.CUSTOMERS);
  };

  return (
    <Wrapper>
      <Content>
        {activeFilter && (
          <Overlay onClick={() => _toggleFilter(activeFilter)} />
        )}
        <Date
          onClick={() => _toggleFilter(carbonFiltersEnum.DATE)}
          isOpen={activeFilter === carbonFiltersEnum.DATE}
          onApply={_applyDate}
        />
        <Subsidiaries
          onClick={() => _toggleFilter(carbonFiltersEnum.SUBSIDIARIES)}
          isOpen={activeFilter === carbonFiltersEnum.SUBSIDIARIES}
          onApply={_applySubsidiariesFilter}
        />
        <Regions
          onClick={() => _toggleFilter(carbonFiltersEnum.REGIONS)}
          isOpen={activeFilter === carbonFiltersEnum.REGIONS}
          onApply={_applyRegionFilter}
        />
        <Invoice
          onClick={() => _toggleFilter(carbonFiltersEnum.NF_TYPE)}
          isOpen={activeFilter === carbonFiltersEnum.NF_TYPE}
          onApply={_applyNFTypeFilter}
        />
        <Modal
          onClick={() => _toggleFilter(carbonFiltersEnum.MODAL)}
          isOpen={activeFilter === carbonFiltersEnum.MODAL}
          onApply={_applyModal}
        />
        <Customers
          onClick={() => _toggleFilter(carbonFiltersEnum.CUSTOMERS)}
          isOpen={activeFilter === carbonFiltersEnum.CUSTOMERS}
          onApply={_applyCustomersFilter}
        />
      </Content>
    </Wrapper>
  );
};

export default connect()(CarbonFilters);
